export default class STRIPE_CONSTANTS {
  public static readonly URLS = {
    'settings': 'https://dashboard.stripe.com/',
    'reports_link': 'https://dashboard.stripe.com/reports/hub',
    'payouts': 'https://dashboard.stripe.com/settings/payouts',
    'tax_rate': 'https://dashboard.stripe.com/tax-rates',
    'coupons': 'https://dashboard.stripe.com/coupons',
    'payment_methods': 'https://dashboard.stripe.com/settings/payment_methods'
  };
}